<section *ngIf="visible" class="announcement-bar relative color1 bg-color5" [@slideOut]>
    <span>{{announcement}}</span>
    <i nz-icon class="close-icon cursor-pointer" nzType="close" (click)="closeAnnouncement()"></i>
</section>
